import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { BILLING_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";

export type PaymentPlan = Partial<{
  id: number;
  transactionId: number;
  invoiceId: number;
  status:
    | "Pending"
    | "Paid"
    | "Declined"
    | "Auto Charge Attempt Failed"
    | "Deferred"
    | "Error"
    | "Hold"
    | "On Hold"
    | "Next"
    | "Refunded"
    | "Tentative"
    | "Discount"
    | "Cancelled"
    | "NA";
  date: number;
  amount: string;
  method: string;
  ca: number;
  cb: number;
  lma: number;
  lmb: number;
  createdByName: string;
  currency: number;
  currencySymbol: number;
  isExpired: boolean;
  timeRemaining: string | number;
  transactionMethod: string;
  transactionCurrency: string;
  transactionCurrencySymbol: string;
  transactionAmount: string;
  transactionProcessor: string;
  transactionDate: number;
  transactionDepartmentId: number;
}>;

type Result = Array<PaymentPlan>;
type QueryError = {};

const useInvoicePaymentPlansQuery = (
  invoiceId: number | undefined,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${BILLING_ENDPOINT}/payment-plans/invoice/${invoiceId}`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url, invoiceId];

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!invoiceId) throw new Error();

      const res = await fetchWithAuth<Result>(url);

      return res;
    },
    {
      enabled: !!invoiceId,
      ...options,
    }
  );
};
export default useInvoicePaymentPlansQuery;
